export default __webpack_public_path__ + "static/media/gears-384744_1920.b6da2399.jpg";